/**
 * TenantUsageView — `/settings/usage` (Doc 25 §F3).
 *
 * Dashboard de consumo de IA del tenant. Tenant admin ve totales del
 * tenant + saldo + threshold. Usuarios normales ven solo sus propias
 * invocaciones (enforced en backend; este componente no oculta UI).
 */

import { Link } from '@tanstack/react-router'
import { isAdmin as isAdminTier } from '../../lib/tiers'
import { useTranslation } from 'react-i18next'
import { ArrowLeft } from 'lucide-react'

import { useMe } from '../../auth/useMe'
import { ScrollPage } from '../../components/shell/ScrollPage'
import { UsageDashboard } from '../../components/usage/UsageDashboard'

export function TenantUsageView() {
  const { t } = useTranslation(['usage', 'sources'])
  const { me } = useMe()
  const isAdmin = isAdminTier(me?.role)

  return (
    <ScrollPage>
      <div className="max-w-7xl">
        <Link
          to="/projects"
          className="inline-flex items-center gap-1.5 text-xs text-ink-muted hover:text-ink mb-4"
        >
          <ArrowLeft className="w-3.5 h-3.5" />
          {t('sources:settings.back_to_projects')}
        </Link>

        <header className="mb-6">
          <h1 className="font-display text-2xl font-semibold text-ink">
            {t('usage:page_title')}
          </h1>
          <p className="mt-1 font-body text-sm text-ink-muted max-w-prose">
            {t('usage:page_subtitle')}
          </p>
        </header>

        <UsageDashboard showBalance={isAdmin} />
      </div>
    </ScrollPage>
  )
}
